<div class="attachments">
  <div class="d-flex">
    <div class="align-self-start mr-3 p-2">
      <i class="fas fa-paperclip icon-size-bigger attachment-icon"></i>
    </div>
    <div class="d-flex flex-column attachment-list">
      <div class="attached-files">
        <strong>{{ "support_article_attached_files" | i18next: {attachedFiles: attachments.length} }}</strong>
      </div>
      @for (a of attachments; track a) {
      <div class="d-flex flex-row">
        <a class="btn-link">
          <span class="cursor-pointer" (click)="onAttachmentClick(a)">{{ a.fileName }}</span>
        </a>
      </div>
      }
    </div>
  </div>
</div>